module.exports = __webpack_public_path__ + "img/employees.61e21a51.svg";